import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './FeedbackCard.module.scss';
import LinesEllipsis from 'react-lines-ellipsis';
import { IFeedback } from "@common/redux/types/feedbacks";
import { Rating } from "@kursk/components/ui/Rating/Rating";
import moment from "moment";
import classNames from "classnames";
import { ReedMoreArrow } from "@kursk/components/ui/icons";
import { allFeedbackTags } from "@kursk/utils/hashMapFeedbackTags";

interface Props {
  feedback: IFeedback;
}

export const FeedbackCard: FC<Props> = ({ feedback }) => {
  const linesEllipsis: any = useRef(null);
  const [clamped, setClamped] = useState(false);
  const [fontsReady, setFontsReady] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const createDate = moment(feedback.createDate).format('DD MMMM YYYY, HH:mm');

  // custom effect for LinesEllipsis (onload fonts clamp description)
  useEffect(() => {
    document.fonts.ready.then(() => setFontsReady(true));
  }, []);

  useEffect(() => {
    if (linesEllipsis && linesEllipsis?.current?.isClamped()) {
      setClamped(linesEllipsis.current.isClamped());
    }
  }, [linesEllipsis, fontsReady]);

  return (
    <div className={styles.card}>
      <div className={styles.title}>
        {feedback.user.name}
      </div>
      <div className={styles.subTitle}>
        <div className={styles.rating}>
          <Rating
            rating={feedback.value}
            count={5}
            noSelectedColorStar='#e5e5e5'
            withoutNumber
          />
        </div>
        <div className={styles.createDate}>
          {createDate}
        </div>
      </div>
      <div className={styles.tags}>
        {feedback.tags.map((tag, index) => (
          <div
            key={index}
            className={classNames([
              styles.tag,
              allFeedbackTags.get(tag).maxRating <= 3 ? styles.bad : styles.good
            ])}>
            {allFeedbackTags.get(tag).name}
          </div>
        ))}
      </div>
      <LinesEllipsis
        ref={linesEllipsis}
        text={feedback.description}
        maxLine={3}
        trimRight
        basedOn='letters'
        className={classNames([styles.description])}
      />
      {clamped && (
        <div className={styles.reedMore} onClick={() => setReadMore(true)}>
          Читать полностью
          <ReedMoreArrow/>
        </div>
      )}
      {readMore && (
        <div className={styles.fullDescriptionWrap}>
          <pre className={styles.fullDescription}>
            {feedback.description}
          </pre>
          <div className={styles.cancelDescription} onClick={() => setReadMore(false)}>
            <ReedMoreArrow/> Закрыть
          </div>
        </div>
      )}
    </div>
  );
};
